module.exports = __webpack_public_path__ + "img/mt6.e29358af.jpg";